/**
 * Data-feed access grant contract (admin-managed).
 *
 * A grant is a per-person, read-only credential used to connect Excel / Power BI to the
 * OData feed (see {@link ODATA_BASE_PATH}). Each grant carries its own API key, shown once
 * on creation (see {@link DataFeedGrantIssueResult}) and never recoverable afterwards.
 * Grants authenticate via HTTP Basic (any username, the key as the password) so Excel can
 * store the credential in the OS credential manager rather than embedding it in a workbook.
 */
/** Root path (under the app, not the API prefix) where the read-only OData feed is served. */
export const ODATA_BASE_PATH = '/odata';
//# sourceMappingURL=data-feed.js.map